//src/components/auth/YandexLoginButton/index.tsx
import React from 'react';

import styles from './styles.module.scss';

const YandexLoginButton = () => {
  const clientId = process.env.REACT_APP_YANDEX_CLIENT_ID!;
  const redirectUri = `${window.location.origin}/login`;
  const authUrl = `https://oauth.yandex.ru/authorize?response_type=token&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&state=yandex`;

  return (
    <a href={authUrl} className={styles.yandexLoginButton}>
      <img src="/images/yandex.svg" alt="" />
      Войти через Яндекс
    </a>
  );
};


export default YandexLoginButton;
